<template>
  <el-card shadow="hover">
    <div
      v-if="hasSlot || hasHeaderSlot"
      slot="header"
      class="card-header__wrap">
      <div class="card-header--title">
        <slot name="title"></slot>
      </div>
      <div class="card-header--form">
        <slot name="form"></slot>
      </div>
    </div>
    <slot></slot>
    <div class="card-footer">
      <slot name="footer"></slot>
    </div>
  </el-card>
</template>
<script>
export default {
  name: 'LayoutCardWrap',
  props: {
    hasSlot: Boolean,
    hasHeaderSlot: Boolean
  }
}
</script>
<style lang="stylus" scoped>
.card-header__wrap {
  // padding: 18px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .card-header--title {
  }

  .card-header--form {
    display: flex;
    align-items: center;
  }
}

.card-footer {
  // margin: 15px 0 0;
  text-align: center;
}
</style>
